export function clamp(n: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, n));
}

/**
 * Parse input value to a valid integer between min and max.
 * Returns the current value if parsing fails or value is invalid.
 */
export function parseIntegerInput(
  value: string,
  currentValue: number,
  min: number,
  max: number
): number {
  if (value === '') {
    return currentValue;
  }

  const parsed = parseInt(value, 10);

  if (Number.isNaN(parsed) || !Number.isFinite(parsed)) {
    return currentValue;
  }

  return clamp(parsed, min, max);
}
